<template>
  <div class="chart-wrap" ref="mapChartWrap" />
</template>
<script>
import chinaMap from '@/utils/china-provinces.js'
import { Chart, DataView } from '@/utils/g2'
import { formatNum } from '@/utils/strUtil'

export default {
  name: 'DataFans',
  props: {
    chartHeight: {
      type: Number,
      default: 400
    },
    chartData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    chartData(newVal) {
      this.initChart(newVal)
    }
  },
  created() {
    this.dvMap = null
    this.mapChart = null
  },
  beforeDestroy() {
    this.destroyChart()
  },
  methods: {
    initChart(data = []) {
      const { mapChartWrap } = this.$refs
      if (mapChartWrap) {
        if (this.mapChart) {
          this.updateChart(data)
        } else {
          this.renderChart(mapChartWrap, data)
        }
      } else {
        this.$nextTick(() => {
          this.initChart(data)
        })
      }
    },
    renderChart(container, data) {
      this.mapChart = new Chart({
        container,
        autoFit: true,
        height: this.chartHeight,
        padding: [20, 30, 90, 30]
      })
      this.mapChart.tooltip({
        showTitle: false
      })
      // 同步度量
      this.mapChart.scale({
        longitude: {
          sync: true
        },
        latitude: {
          sync: true
        }
      })
      this.mapChart.legend('value', {
        position: 'left',
        offsetY: -100
      })
      this.mapChart.axis(false)
      const dv = new DataView()
      this.dvMap = dv.source(chinaMap, {
        type: 'GeoJSON'
      })
      const worldMapView = this.mapChart.createView()
      worldMapView.data(this.dvMap.rows)
      worldMapView.tooltip(false)
      worldMapView.polygon().position('longitude*latitude').style({
        fill: '#fff',
        stroke: '#ccc',
        lineWidth: 1
      })
      const fansDv = this.updateMapDv(data)
      const fansView = this.mapChart.createView()
      fansView.data(fansDv)
      fansView.scale('value', {
        formatter(val) {
          return formatNum(val)
        }
      })
      fansView.polygon()
        .position('longitude*latitude')
        .color('数量', '#d5e1fe-#0027e2')
        .tooltip('省份*数量')
        .animate({
          leave: {
            animation: 'fadeOut'
          }
        })
      this.mapChart.render()
    },
    updateChart(data) {
      const fansDv = this.updateMapDv(data)
      this.mapChart.changeData(fansDv)
    },
    updateMapDv(data) {
      const dv = new DataView()
      dv.source(data).transform({
        geoDataView: this.dvMap,
        field: 'name',
        type: 'geo.region',
        as: ['longitude', 'latitude']
      }).transform({
        type: 'rename',
        map: {
          name: '省份',
          value: '数量'
        }
      })
      return dv.rows
    },
    destroyChart() {
      if (this.mapChart) {
        this.mapChart.destroy()
        this.mapChart = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.chart-wrap {
  height: 400px;
}
</style>
